import ZApiClient from '../client/z-api-client';

export const getParentBreadcrumb = async (entityType, entityId) => (
  ZApiClient.getClientFromType(entityType).getBreadcrumbs(entityId)
);
